import { getSecurityTypeLabel } from "./columnsConfig/trades";

// TanStack Table's global filter always calls this against the RAW
// accessor value for every column - it does not know about a column's
// own Cell-rendering label lookup. Security_Type displays a friendly
// label (see columnsConfig/trades.js) but is stored/sorted by its raw
// code, so this column needs its own match against both.
export const globalFilterFn = (row, columnId, filterValue) => {
  const rawValue = row.getValue(columnId);
  const search = String(filterValue ?? "").toLowerCase();

  if (columnId === "Security_Type") {
    const label = getSecurityTypeLabel(rawValue);
    return (
      String(rawValue ?? "").toLowerCase().includes(search) ||
      String(label ?? "").toLowerCase().includes(search)
    );
  }

  return String(rawValue ?? "").toLowerCase().includes(search);
};
